import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { environment } from './api/environment';
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
const analytics = getAnalytics(app);

// Connect to Auth emulator if running locally.
//
// In hybrid mode (cloud emulator), devconsole writes
// REACT_APP_FIREBASE_AUTH_EMULATOR_HOST=<lxc-ip>:9099 to
// apps/web/.env.development.local so the browser talks to the
// remote auth emulator instead of localhost. The default,
// `${window.location.hostname}:9099`, works for all-local dev
// (browser at localhost:5010 → auth at localhost:9099) but fails
// when the page is served at 0.0.0.0 — the browser can't actually
// connect to 0.0.0.0 (it's a wildcard bind, not a real address).
if (environment === 'emulator') {
  const authHost =
    process.env.REACT_APP_FIREBASE_AUTH_EMULATOR_HOST ||
    `${window.location.hostname}:9099`;
  connectAuthEmulator(auth, `http://${authHost}`);
}